
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlY as ObiOwnShipControlYElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-y.js';
 
 
 

 
 export const ObiOwnShipControlY = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-y',
   elementClass: ObiOwnShipControlYElement,
   events: {
     
   }
  });
 
 